import { put } from "../../service/api";

const UpdateMerchant = async (id, data) => {
  try {
    const response = await put(`/admin/merchant/${id}`, data);
    return response;
  } catch (error) {
    console.error("Error UpdateMerchant:", error);
    throw error;
  }
};

export default UpdateMerchant;
